import React from 'react';
import styled from 'styled-components';
import { ChevronDownIcon } from '@freenow/wave';
const DropdownIcon = styled.div `
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(-180deg)' : 'rotate(0deg)')};
    background-size: cover;
    background-color: transparent;
    border: none;
    transition: transform 0.1s ease-in-out;
`;
export const DropdownChevronIcon = ({ isOpen }) => (React.createElement(DropdownIcon, { isOpen: isOpen },
    React.createElement(ChevronDownIcon, { size: 20 })));
